import { render } from "./Semicolon0103.vue?vue&type=template&id=23a5a572"
import script from "./Semicolon0103.vue?vue&type=script&lang=js"
export * from "./Semicolon0103.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__